import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconChatWithoutHistory({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#rvc7hp1hka)" fill={fill}>
                <path d="m13.39 9.334-1.883-.822a1.973 1.973 0 0 1-1.016-1.018L9.669 5.61a.182.182 0 0 0-.335 0l-.821 1.884a1.973 1.973 0 0 1-1.017 1.018l-1.887.823a.183.183 0 0 0 0 .335l1.919.849c.454.201.816.566 1.012 1.022l.795 1.849a.182.182 0 0 0 .335 0l.82-1.882a1.973 1.973 0 0 1 1.018-1.018l1.882-.822a.183.183 0 0 0 0-.334zM6.945 4.917l-.941-.411a.986.986 0 0 1-.509-.509l-.41-.942a.091.091 0 0 0-.168 0l-.41.942a.986.986 0 0 1-.51.509l-.942.412a.091.091 0 0 0 0 .167l.959.424c.227.101.408.283.506.512l.398.924a.091.091 0 0 0 .167 0l.41-.941c.1-.228.281-.41.509-.509l.941-.411a.091.091 0 0 0 0-.167z"/>
            </g>
            <defs>
                <clipPath id="rvc7hp1hka">
                    <path fill="#fff" d="M0 0h16v16H0z"/>
                </clipPath>
            </defs>
        </svg>

    );
}

export default IconChatWithoutHistory;

